import { render, staticRenderFns } from "./DemoSliderMinAndMax.vue?vue&type=template&id=35eaa10e&"
import script from "./DemoSliderMinAndMax.vue?vue&type=script&lang=js&"
export * from "./DemoSliderMinAndMax.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../landing-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../landing-app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSlider } from 'vuetify/lib/components/VSlider';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VSlider,VTextField})
